<template>
    <OEENYX ref="OEENYX" v-if="formulaNyx && permisoVista('dashboard','r')"/>
    <v-col cols="12" class="px-8" v-else-if="permisoVista('dashboard','r')">
      <v-snackbar v-model="error" top color="error">
		    	<ul>
		    		<li v-for="(e, i) in errores" :key="i">{{ e }}</li>
		    	</ul>
		    	<v-btn text @click="error = false"> Cerrar </v-btn>
		    </v-snackbar>
      <template v-if="!modoProyeccion ">
        <v-row class="mt-0">          
          <v-col cols="4" md="4" sm="4" class="align-self-end">
            <!-- @input="obtenerDatos" -->
            <datePicker
              v-model="filtros.desde"
                  format="YYYY-MM-DD"
                  label="Desde (Obligatorio)"
                  clearable
                  maxToday
                  
                  :disabled="cargando"
              :maxDate="filtros.hasta"
                ></datePicker>
          </v-col>
          <v-col cols="4" md="4" sm="4" class="align-self-end">
            <!-- @input="obtenerDatos" -->
            <datePicker
            v-model="filtros.hasta"
                  format="YYYY-MM-DD"
                  label="Hasta (Obligatorio)"
                  clearable
                  maxToday
                  
                  :disabled="cargando"
              :minDate="filtros.desde"
                ></datePicker>
          </v-col>
          <v-col cols="4" md="4" sm="4">
            <!-- <v-autocomplete
              v-model="filtros.idsTurnos"
              :items="turnos"
              item-value="idTurno"
              item-text="nombre"
              label="Turnos (Opcional)"
              hide-details
              clearable
              multiple
              chips
              deletable-chips
              :disabled="cargando"
              @input="obtenerDatos"
              @click:clear="resetCampo(1)"
            >
            </v-autocomplete> -->
            <!-- @input="obtenerDatos" -->
            <v-autocomplete
              v-model="filtros.idsTurnos"
              :items="turnos"
              item-value="idTurno"
              item-text="nombre"
              label="Turnos (Opcional)"
              hide-details
              clearable
              multiple
              chips
              deletable-chips
              :disabled="cargando"
              
              @click:clear="resetCampo(1)"
            >
            </v-autocomplete>
          </v-col>
        </v-row>
        <v-row>
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div>
                  <v-icon>mdi-target</v-icon> Filtros Avanzados (Opcionales)
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row>
                  <v-col cols="4" md="4" sm="4">
                    <!-- @input="obtenerDatos" -->
                    <v-autocomplete
                      v-model="filtros.idsAreas"
                      :items="areas"
                      item-value="idArea"
                      item-text="nombre"
                      label="Áreas"
                      hide-details
                      clearable
                      multiple
                      chips
                      deletable-chips
                      :disabled="cargando"
                      
                      @click:clear="resetCampo(2)"
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="4" md="4" sm="4">
                    <!-- @input="obtenerDatos" -->
                    <v-autocomplete
                      v-model="filtros.idsOTS"
                      :items="ots"
                      item-value="idTrabajoOrden"
                      item-text="clave"
                      label="Orden de Trabajo"
                      hide-details
                      clearable
                      multiple
                      chips
                      deletable-chips
                      :disabled="cargando"
                      
                      @click:clear="resetCampo(3)"
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="4" md="4" sm="4">
                    <!-- @input="obtenerDatos" -->
                    <v-autocomplete
                      v-model="filtros.idsArticulos"
                      :items="articulos"
                      item-value="idArticulo"
                      :item-text="nombreArticulo"
                      label="Artículos"
                      hide-details
                      clearable
                      multiple
                      chips
                      deletable-chips
                      :disabled="cargando"
                      
                      @click:clear="resetCampo(4)"
                    >
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="4" md="4" sm="4">
                    <!-- @input="obtenerDatos" -->
                    <v-autocomplete
                      v-model="filtros.idsMaquinaInstancias"
                      :items="maquinasIns"
                      item-value="idMaquinaIns"
                      :item-text="nombreMaquina"
                      label="Maquinas Instancias"
                      hide-details
                      clearable
                      multiple
                      chips
                      deletable-chips
                      :disabled="cargando"
                      
                      @click:clear="resetCampo(5)"
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="4" md="4" sm="4">
                    <!-- @input="obtenerDatos" -->
                    <v-autocomplete
                      v-model="filtros.idsPersonas"
                      :items="operadores"
                          item-value="idPersona"
                          :item-text="nombrePersona"
                      label="Personas"
                      hide-details
                      clearable
                      multiple
                      chips
                      deletable-chips
                      :disabled="cargando"
                      
                      @click:clear="resetCampo(6)"
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="4" md="4" sm="4">
                    <!-- @input="obtenerDatos" -->
                    <v-autocomplete
                      v-model="filtros.idsClientes"
                      :items="clientes"
                      item-text="nombre"
                      item-value="idCliente"
                      label="Clientes"
                      hide-details
                      clearable
                      multiple
                      chips
                      deletable-chips
                      :disabled="cargando"
                      
                      @click:clear="resetCampo(7)"
                    >
                    </v-autocomplete>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-row>
        <v-row>
          <v-btn color="primary" dark class="mb-2" @click="consultar()">Consultar</v-btn>
          <download-btn
            v-if="!formulaNyx"
            className="my-4"
            color="blue darken-1"
            text
            @click="descargarReporte"
            label="Descargar Reporte de OEE"
          />
        </v-row>
        <br>
      </template>
      <div v-if="viewData ">
        <v-row v-if="realizarPeticion && sameDay" class="px-0 ma-0">
        <v-col cols="12" class="ma-0 text-right text-subtitle-2 d-flex flex-column">
          Proxima Actualización en {{tiempo}}
          <div v-if="!modoProyeccion" class="text-right d-flex my-n5">
            <div class="ml-auto">
              <v-switch v-model="switch1"
               label="Desactivar actualización automática"
               @change="stopTimer"
              ></v-switch>
            </div>
          </div>
        </v-col>
      </v-row>
      <!-- Apartado donde veremos los promedios de los datos -->
          <v-row v-if="!cargando" class="justify-center ma-0 pa-0" >
            <v-col v-if="validarNuevoReporte()" cols="3" md="3" sm="3">
			      	<v-card  class="fill-height d-flex" color="#2a6099" dark>
			      		<v-card-text
			      			class="text-center align-self-center white--text"
			      		>
			      			<div class="subtitle-1 font-weight-bold">
			      				Disponibilidad
			      			</div>
			      			<ICountUp
			      				:delay="1000"
			      				:endVal="this.nuevoReporteOee?this.datos.disponibilidad:this.datos.disponibilidad * 100"
			      				class="subtitle-1 font-weight-medium"
			      				:options="{
                      decimalPlaces: 2,
                      decimal: '.',
			      					suffix: '%'
                    }"
			      			/>
			      		</v-card-text>
			      	</v-card>        
			      </v-col>
			      <v-col v-if="validarNuevoReporte()" cols="3" md="3" sm="3">
			      	<v-card class="fill-height d-flex" color="#2a6099" dark>
			      		<v-card-text
			      			class="text-center align-self-center white--text"
			      		>
			      			<div class="subtitle-1 font-weight-bold">
			      				{{oeeRendimientoLabel}}
			      			</div>
			      			<ICountUp
			      				:delay="1000"
			      				:endVal="this.nuevoReporteOee ?this.datos.eficiencia:this.datos.eficiencia * 100"
			      				class="subtitle-1 font-weight-medium"
			      				:options="{
                      decimalPlaces: 2,
                      decimal: '.',
			      					suffix: '%'
                    }"
			      			/>
			      		</v-card-text>
			      	</v-card>
			      </v-col>      
			      <v-col v-if="validarNuevoReporte()" cols="3" md="3" sm="3">
			      	<v-card class="fill-height d-flex" color="#2a6099" dark>
			      		<v-card-text
			      			class="text-center align-self-center white--text"
			      		>
			      			<div class="subtitle-1 font-weight-bold">{{formulaNyx?`FTQ`:`Calidad`}}</div>
			      			<ICountUp
			      				:delay="1000"
			      				:endVal="this.nuevoReporteOee ?this.datos.calidad:this.datos.calidad * 100"
			      				class="subtitle-1 font-weight-medium"
			      				:options="{
                      decimalPlaces: 2,
                      decimal: '.',
			      					suffix: '%'
                    }"
			      			/>
			      		</v-card-text>
			      	</v-card>
			      </v-col>
			      <v-col v-if="validarNuevoReporte()" cols="3" md="3" sm="3">
			      	<v-card class="fill-height d-flex" color="#2a6099" dark>
			      		<v-card-text
			      			class="text-center align-self-center white--text"
			      		>
			      			<div class="subtitle-1 font-weight-bold">OEE</div>
			      			<ICountUp
			      				:delay="1000"
			      				:endVal="this.nuevoReporteOee ?this.datos.oee:this.datos.oee * 100"
			      				class="subtitle-1 font-weight-medium"
			      				:options="{
                      decimalPlaces: 2,
                      decimal: '.',
			      					suffix: '%'
                    }"
			      			/>
			      		</v-card-text>
			      	</v-card>
			      </v-col>
            <Velocimetro v-if="!validarNuevoReporte() && formulaNyx" ref="velEFICIENCIA" v-model="this.datos.oee" :dataText="`OEE `" sizePx="300" :showText="true" />
            <Velocimetro v-if="!validarNuevoReporte() && formulaNyx" ref="velEFICIENCIA" v-model="this.datos.tiempoMuerto" :dataText="`Tiempo Muerto `" sizePx="300" :showText="true" />
            <!-- disponibilidad -->
            <Velocimetro v-if="!validarNuevoReporte() && !formulaNyx" ref="velEFICIENCIA" v-model="this.datos.disponibilidad" :dataText="`Disponiblilidad `" sizePx="300" :showText="true" />
            <Velocimetro v-if="!validarNuevoReporte() && !formulaNyx" ref="velEFICIENCIA" v-model="this.datos.eficiencia" :dataText="`Rendimiento `" sizePx="300" :showText="true" />
            <Velocimetro v-if="!validarNuevoReporte()" ref="velEFICIENCIA" v-model="this.datos.calidad" :dataText="formulaNyx?`FTQ `:`Calidad `" sizePx="300" :showText="true" />
            <Velocimetro v-if="!validarNuevoReporte() && !formulaNyx" ref="velEFICIENCIA" v-model="this.datos.oee" :dataText="`OEE `" sizePx="300" :showText="true" />
          </v-row>
      <!-- En el caso de que desde y hasta sean iguales, se muentran el promedio de los turnos de ese dia v-for="item in datos.resumenTurno"-->
      <v-row v-if="!cargando && !validarNuevoReporte() "  class="justify-center ma-0 pa-0">        
        <v-col v-if="formulaNyx" cols="3">
          <apexchart  height="220" style="margin: auto;" width="100%" :options="serie8" :series="chartOptions8" ></apexchart>
        </v-col>
        <v-col cols="3">
          <apexchart v-if="!formulaNyx" height="220" style="margin: auto;" width="100%" :options="serie5" :series="chartOptions5"  ></apexchart>
        </v-col>
        <v-col v-if="!formulaNyx" cols="3" md="3" sm="3">
          <apexchart  height="220" style="margin: auto;" width="100%" :options="serie6" :series="chartOptions6" ></apexchart>
        </v-col>
        <v-col cols="3">
          <apexchart height="220" style="margin:auto;" width="100%" :options="serie7" :series="chartOptions7"  ></apexchart>  
        </v-col>
        <v-col v-if="!formulaNyx" cols="3">
          <apexchart  height="220" style="margin:auto;" width="100%" :options="serie8" :series="chartOptions8" ></apexchart> 
        </v-col>                                                  
      </v-row>
      
      <!-- Graficas -->
      <v-row v-if="!cargando && renderizar && validarNuevoReporte() ">
        <v-col cols="6" md="6" sm="6" class="text-center">
          <div class="text-subtitle-2">Disponibilidad</div>
          <apexchart height="220" :options="serie1" :series="chartOptions1" @xAxisLabelClick="filtrarData" ></apexchart>
          <v-btn elevation="2" v-if="efode" color="primary" x-small @click="eliminarFiltro(1)" >Eliminar filtro</v-btn>
        </v-col>
        <v-col cols="6" md="6" sm="6" class="text-center">
          <div class="text-subtitle-2">{{oeeRendimientoLabel}}</div>
          <apexchart height="220" :options="serie2" :series="chartOptions2" @xAxisLabelClick="filtrarData"></apexchart>
          <v-btn elevation="2" v-if="efore" color="primary" x-small @click="eliminarFiltro(2)" >Eliminar filtro</v-btn>
        </v-col>
        <v-col cols="6" md="6" sm="6" class="text-center">
          <div class="text-subtitle-2">{{formulaNyx?"FTQ":"Calidad"}}</div>
          <apexchart height="220" :options="serie3" :series="chartOptions3" @xAxisLabelClick="filtrarData" ></apexchart>
          <v-btn elevation="2" v-if="efoce" color="primary" x-small @click="eliminarFiltro(3)" >Eliminar filtro</v-btn>
        </v-col>
        <v-col cols="6" md="6" sm="6" class="text-center">
          <div class="text-subtitle-2">OEE</div>
          <apexchart height="220" :options="serie4" :series="chartOptions4" @xAxisLabelClick="filtrarData"></apexchart>
          <v-btn elevation="2" v-if="efoee" color="primary" x-small @click="eliminarFiltro(4)" >Eliminar filtro</v-btn>
        </v-col>
      </v-row>
      <!-- Ranking de maquinas -->
      <v-row v-if="!cargando && renderizar" class="justify-center ma-0 pa-0">
        <v-col cols="6" md="6" sm="6" class="text-center">
          <div class="d-flex align-center">
            <v-icon left>mdi-alert-circle-outline</v-icon> Peores OEE
          </div>
          <!-- <v-data-table
          :headers="headersPeoresTop"
          :items="datos.peoresMaquinas"
          item-key="id"
          fixed-header
          height="290px"
          
          >          
            <template v-slot:[`item.oee`]="{ item }">
              {{(item.oee).toFixed(2)}}%
            </template>          
          </v-data-table> -->
          <apexchart  height="220" style="margin:auto;" width="100%" :options="serie9" :series="chartOptions9" ></apexchart>
        </v-col>       
      </v-row>
      <!-- Tablas -->
      <v-row v-if="!cargando && renderizar && datos.operaciones.length > 0 && !modoProyeccion ">
        <v-col cols="12" md="12" sm="12">
          <v-expansion-panels multiple>
            <!-- Tabla Hora x Hora -->
            <!-- Ponemos una condicionante ligada a la variable de entorno para que muestre la manera en la que se ve el reporte en oee en Nyx -->
            <v-expansion-panel v-if="formulaNyx" class="my-2">
              <v-expansion-panel-header>
                <div class="d-flex align-center">
                  <v-icon left>mdi-clipboard-text-clock-outline</v-icon> Hora x Hora
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-data-table
                  :items="datos.resumenHoras"
                  :headers="resumenHorasHeaders"
                >
                  <template v-slot:[`item.maquina`]="{ item }">
                      <ul>
                        <li v-for="(m,idx) in item.maquina" :key="'m-'+idx">{{m}}</li>
                      </ul>
                    </template>
                  <template v-slot:[`item.tiempoParo`]="{ item }">
                    <td class="text-center">
                      {{item.tiempoParo}} min
                    </td >                    
                  </template> 
                  <!-- <template v-slot:[`item.fechaInicioDate`]="{ item }">
                    {{ item.fechaInicioDate | formatStringFecha }}
                  </template>
                  <template v-slot:[`item.fechaFinDate`]="{ item }">
                    {{ item.fechaFinDate | formatStringFecha }}
                  </template>
                  <template v-slot:[`item.disponibilidad`]="{ item }">
                    {{ item.disponibilidad | formatToPercentage }}
                  </template>
                  <template v-slot:[`item.eficiencia`]="{ item }">
                    {{ item.eficiencia | formatToPercentage }}
                  </template>
                  <template v-slot:[`item.calidad`]="{ item }">
                    {{ item.calidad | formatToPercentage }}
                  </template> -->
                  <template v-slot:[`item.oee`]="{ item }">
                    {{ item.oee }}%
                  </template>
                </v-data-table>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <!-- Tabla de operaciones -->
            <v-expansion-panel class="my-2">
              <v-expansion-panel-header>
                <div class="d-flex align-center">
                  <v-icon left>mdi-cog</v-icon> Operaciones
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-data-table
                  :headers="headers"
                  :items="datos.operaciones"
                  item-key="id"
                  show-expand
                  fixed-header
                  height="600px"
                  :expanded.sync="expanded"
                >
                  <template v-slot:[`item.subpaso`]="{ item }">
                    <span v-if="item.codigo || item.descripcion">
                      [{{ item.codigo || '' }}] - {{ item.descripcion || '' }}
                    </span>
                    <span v-else>N/A</span>
                  </template>
                  <template v-slot:[`item.disponibilidad`]="{ item }">
                    {{(nuevoReporteOee ?item.disponibilidad:item.disponibilidad * 100).toFixed(2)}}%
                  </template>
                  <template v-slot:[`item.eficiencia`]="{ item }">
                    {{(nuevoReporteOee ?item.eficiencia:item.eficiencia * 100).toFixed(2)}}%
                  </template>
                  <template v-slot:[`item.calidad`]="{ item }">
                    {{(nuevoReporteOee ?item.calidad:item.calidad * 100).toFixed(2)}}%
                  </template>
                  <template v-slot:[`item.oee`]="{ item }">
                    {{(nuevoReporteOee ?item.oee:item.oee * 100).toFixed(2)}}%
                  </template>
                  <template v-slot:[`item.maquinas`]="{ item }">
                    <ul>
                      <li v-for="(m,idx) in item.maquinas" :key="'m-'+idx">{{m}}</li>
                    </ul>
                  </template>
                  <template v-slot:[`item.personas`]="{ item }">
                    <ul>
                      <li v-for="(p,idx) in item.personas" :key="'p-'+idx">{{p}}</li>
                    </ul>
                  </template>
                  <template v-slot:expanded-item="{ headers, item }">
                    <td :colspan="headers.length">
                      <br>
                      <v-simple-table>
                        <template v-slot:default>
                          <thead>
                            <tr>
                              <th class="text-center">
                                Inicio
                              </th>
                              <th class="text-center">
                                Fin
                              </th>
                              <th v-if="nuevoReporteOee" class="text-center">
                                Tiempo evaluado
                              </th>
                              <th class="text-center">
                                Tiempo activo
                              </th>
                              <th v-if="!formulaNyx" class="text-center">
                                STD
                              </th>
                              <th v-else class="text-center">
                                TC
                              </th>
                              <th class="text-center">
                                Total Piezas
                              </th>
                              <th class="text-center">
                                Piezas Teoricas
                              </th>
                              <th class="text-center">
                                Piezas Ok
                              </th>
                              <th class="text-center">
                                Total No Ok
                              </th>
                              <th class="text-center">
                                Paros
                              </th>
                              <th class="text-center">
                                Scrap
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td class="text-center">{{item.inicioString}}</td>
                              <td class="text-center">{{item.finString}}</td>
                              <td class="text-center">{{$utils.strings.toTime(item.tiempoOperacionSeg)}}</td>
                              <td class="text-center">{{$utils.strings.toTime(nuevoReporteOee?item.tiempoNeto*3600:item.tiempoOperacionSeg)}}</td>
                              <td v-if="!formulaNyx" class="text-center">{{item.std}}</td>
                              <td v-else class="text-center">{{item.tiempoCiclo+" seg"}}</td>
                              <td class="text-center">{{item.totalPiezas}}</td>
                              <td class="text-center">{{item.piezasTeoricas}}</td>
                              <td class="text-center">{{item.piezasOk}}</td>
                              <td class="text-center">{{item.piezasNoOk}}</td>
                              <td class="text-center">
                                {{item.paroReporte.length}} {{ item.paroReporte.length == 1 ? 'Paro' : 'Paros'    }}
                                <br>
                                {{$utils.strings.toTime(nuevoReporteOee?item.tiempoParos*3600:item.tiempoParos)}}
                              </td>
                              <td class="text-center">{{(item.scrap * 100).toFixed(2)}}%</td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                      <br>
                    </td>
                  </template>
                </v-data-table>
              </v-expansion-panel-content>
            </v-expansion-panel>  
            <!-- Tabla con el promediado de las operaciones -->
            <v-expansion-panel class="my-2">
              <v-expansion-panel-header>
                <div class="d-flex align-center">
                  <v-icon left>mdi-calendar-today</v-icon> Resumen por dia
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-data-table
                  :headers="headersXDia"
                  :items="datos.resumenDias"
                  item-key="id"
                  show-expand
                  fixed-header
                  height="600px"
                  :expanded.sync="expanded1"
                >
                  
                  <template v-slot:[`item.tiempoBruto`]="{ item }">
                    <td v-if="!formulaNyx" class="text-center">
                      {{$utils.strings.toTime(item.tiempoBruto*3600)}}
                    </td >
                    <td v-else class="text-center">
                      {{$utils.strings.toTime(item.tiempoBruto)}}
                    </td>
                  </template>
                  <template v-slot:[`item.tiempoNeto`]="{ item }">
                    <td v-if="!formulaNyx" class="text-center">
                      {{$utils.strings.toTime(item.tiempoNeto*3600)}}
                    </td >
                    <td v-else class="text-center">
                      {{$utils.strings.toTime(item.tiempoNeto)}}
                    </td>                    
                  </template>
                  <template v-slot:[`item.reportes`]="{ item }">
                    <td v-if="!formulaNyx" class="text-center">
                      {{item.reportes}} {{ item.reportes == 1 ? 'Paro' : 'Paros'    }}
                      <br>
                      {{$utils.strings.toTime(item.tiempoParos*3600)}}
                    </td >
                    <td v-else class="text-center">
                      {{item.reportes}} {{ item.reportes == 1 ? 'Paro' : 'Paros'    }}
                    </td>                    
                  </template>
                  <template v-slot:[`item.scrap`]="{ item }">
                    {{(item.scrap * 100).toFixed(2)}}%
                  </template>
                  <template v-slot:expanded-item="{ headers, item }">
                    <td :colspan="headers.length">
                      <br>
                      <v-simple-table>
                        <template v-slot:default>
                          <thead>
                            <tr>
                              <th v-if="formulaNyx" class="text-center">
                                OEE
                              </th> 
                              <th class="text-center">
                                Disponibilidad
                              </th>
                              <th  v-if="!formulaNyx" class="text-center">
                                Rendimiento
                              </th>
                              <th class="text-center">
                                Calidad
                              </th>
                              <th v-if="!formulaNyx" class="text-center">
                                OEE
                              </th> 
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td v-if="formulaNyx" class="text-center">{{item.oee}}%</td> 
                              <td class="text-center">{{item.disponibilidad}}%</td>
                              <td v-if="!formulaNyx" class="text-center">{{item.eficiencia}}%</td>
                              <td class="text-center">{{item.calidad}}%</td>
                              <td v-if="!formulaNyx" class="text-center">{{item.oee}}%</td>                   
                              
                              <!-- <td class="text-center">{{(item.scrap * 100).toFixed(2)}}%</td> -->
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                      <br>
                    </td>
                  </template>
                </v-data-table>
              </v-expansion-panel-content>
            </v-expansion-panel> 
            <!-- tabla de aquinas por dias -->
            <v-expansion-panel v-if="formulaNyx" class="my-2">
              <v-expansion-panel-header>
                <div class="d-flex align-center">
                  <v-icon left>mdi-washing-machine</v-icon> Resumen por Maquina
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-data-table
                  :headers="headersXMaquina"
                  :items="datos.maquinas"
                  item-key="id"
                  show-expand
                  fixed-header
                  height="600px"
                  :expanded.sync="expanded2"
                >
                  
                  <!-- <template v-slot:[`item.tiempoBruto`]="{ item }">
                    <td v-if="!formulaNyx"class="text-center">
                      {{$utils.strings.toTime(item.tiempoBruto*3600)}}
                    </td >
                    <td v-else class="text-center">
                      {{$utils.strings.toTime(item.tiempoBruto)}}
                    </td>
                  </template>
                  <template v-slot:[`item.tiempoNeto`]="{ item }">
                    <td v-if="!formulaNyx"class="text-center">
                      {{$utils.strings.toTime(item.tiempoNeto*3600)}}
                    </td >
                    <td v-else class="text-center">
                      {{$utils.strings.toTime(item.tiempoNeto)}}
                    </td>                    
                  </template> -->
                  <template v-slot:[`item.reportes`]="{ item }">
                    <td v-if="!formulaNyx" class="text-center">
                      {{item.reportes}} {{ item.reportes == 1 ? 'Paro' : 'Paros'    }}
                      <br>
                      {{$utils.strings.toTime(item.tiempoParos*3600)}}
                    </td >
                    <td v-else class="text-center">
                      {{item.reportes}} {{ item.reportes == 1 ? 'Paro' : 'Paros'    }}
                    </td>                    
                  </template>
                  <template v-slot:[`item.scrap`]="{ item }">
                    {{(item.scrap * 100).toFixed(2)}}%
                  </template>
                  <template v-slot:expanded-item="{ headers, item }">
                    <td :colspan="headers.length">
                      <br>
                      <v-simple-table>
                        <template v-slot:default>
                          <thead>
                            <tr>
                              <th class="text-center">
                                OEE
                              </th> 
                              <th class="text-center">
                                Disponibilidad
                              </th>
                              <!-- <th  v-if="!formulaNyx"class="text-center">
                                Rendimiento
                              </th> -->
                              <th class="text-center">
                                Calidad
                              </th>
                              <!-- <th v-if="!formulaNyx" class="text-center">
                                OEE
                              </th>  -->
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td class="text-center">{{item.oee}}%</td> 
                              <td class="text-center">{{item.disponibilidad}}%</td>
                              <!-- <td class="text-center">{{item.eficiencia}}%</td> -->
                              <td class="text-center">{{item.calidad}}%</td>
                              <!-- <td class="text-center">{{item.oee}}%</td>                    -->
                              
                              <!-- <td class="text-center">{{(item.scrap * 100).toFixed(2)}}%</td> -->
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                      <br>
                    </td>
                  </template>
                </v-data-table>
              </v-expansion-panel-content>
            </v-expansion-panel> 
          </v-expansion-panels>          
        </v-col>
      </v-row>
      </div>
      <div v-if="cargandoData ">
        <v-col cols="12" md="12" sm="12" class="text-center">
                          <h4>Cargando</h4>
                      </v-col>
                      <v-col cols="12" md="12" sm="12" class="text-center">
                          <v-progress-circular
                              :size="75"
                              color="green"
                              indeterminate
                          ></v-progress-circular>
                      </v-col>
      </div>
      








      <!-- <template >
        <v-row class="mt-0">
          <v-col cols="4" md="4" sm="4">
            <v-autocomplete v-model="filtros.arielrIdsMaquinaInstancias" :items="maquinasIns" item-value="idMaquinaIns"
              :item-text="nombreMaquina" label="Maquinas Instancias (Obligatorio)" hide-details clearable deletable-chips
              :disabled="cargando" @input="arielrObtenerDatosNyx" @click:clear="resetCampo(5)" />
          </v-col>
          <v-col cols="4" md="4" sm="4" class="align-self-end">
            <datePicker v-model="filtros.desde" format="YYYY-MM-DD" label="Fecha (Obligatorio)" clearable maxToday
              @input="arielrObtenerDatosNyx" :disabled="cargando" :maxDate="filtros.hasta"/>
          </v-col>
          <v-col cols="4" md="4" sm="4">
            <v-autocomplete v-model="filtros.arielrIdsTurnos" :items="turnos" item-value="idTurno" item-text="nombre" 
              label="Turnos (Obligatorio)" hide-details clearable deletable-chips :disabled="cargando" 
              @input="arielrObtenerDatosNyx" @click:clear="resetCampo(1)" />
          </v-col>
        </v-row>
        <br>
      </template> -->
      <!-- <div v-if=" viewData">
        <v-row v-if="realizarPeticion && sameDay" class="px-0 ma-0">
          <v-col cols="12" class="ma-0 text-right text-subtitle-2 d-flex flex-column">
            Proxima Actualización en {{tiempo}}
            <div v-if="!modoProyeccion" class="text-right d-flex my-n5">
              <div class="ml-auto">
                <v-switch v-model="switch1"
                label="Desactivar actualización automática"
                @change="stopTimer"
                ></v-switch>
              </div>
            </div>
          </v-col>
        </v-row>
      </div> -->
      <!-- <div v-if="cargandoData">
        <v-col cols="12" md="12" sm="12" class="text-center">
            <h4>Cargando</h4>
        </v-col>
        <v-col cols="12" md="12" sm="12" class="text-center">
          <v-progress-circular :size="75" color="green" indeterminate />
        </v-col>
      </div> -->
      <!-- <v-row v-if="!arielrNYX && !cargandoData && arielrNyxOEEData != null" style="margin-top: 50px; margin-bottom: 50px;">
        <v-spacer></v-spacer>
        <Velocimetro v-model="arielrNyxOEEData.oee" :dataText="`OEE`" :showText="true" style="width: 100%; aspect-ratio: 1;"/>
        <v-spacer></v-spacer>
        <Velocimetro v-model="arielrNyxOEEData.tiempoMuerto" :dataText="`Tiempo Muerto`" :showText="true"/>
        <v-spacer></v-spacer>
        <Velocimetro v-model="arielrNyxOEEData.calidad" :dataText="`Calidad`" :showText="true"/>
        <v-spacer></v-spacer>
      </v-row> -->
    </v-col>
  </template>
    
  <script>
  import { mapState } from 'vuex';
  import axios from "axios";
  import ICountUp from "vue-countup-v2";
  import moment from "moment";
  import DownloadBtn from '../../DownloadBtn.vue';
  import Velocimetro from '../../Velocimetro.vue';
  import OEENYX from "./OEENYX.vue"
  
  export default {
      components: {
        OEENYX,
          ICountUp,
      DownloadBtn,
      Velocimetro
      },
    props: {
      modoProyeccion: {
        type: Boolean,
        default: false
      },
      update: {
        type: Number,
        default: 5
      },
          active: {
              type: Boolean,
              default: false,
          },
      },
      computed: {
      idTurnoActual(){
        const currentTime = new Date();
        const turnoActual = this.turnos.find(turno => {
          const start = this.$utils.strings.stringToTime(turno.inicio);
          const end = this.$utils.strings.stringToTime(turno.fin);
          // Manejar el caso en que el rango cruce la medianoche
          if (start > end) {
            return currentTime >= start || currentTime <= end;
          } else {
            return currentTime >= start && currentTime <= end;
          }
        });
        return turnoActual?.idTurno || null;
      },
      itemsConSubpaso() {
        return this.operaciones.map(o => ({
          ...o,
          subpaso: (o.codigo || o.descripcion)
            ? `[${o.codigo ?? ''}] - ${o.descripcion ?? ''}`
            : 'N/A'
        }))
      },
      today(){
        return (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10);
      },
      ...mapState({
        nombreEmpresa: 'nombreEmpresa',
        oeeRendimientoLabel: 'oeeRendimientoLabel',
        nuevoReporteOee: 'nuevoReporteOee',
        formulaNyx: 'formulaNyx',
      }),
          realizarPeticion() {
              return this.$utils.isValid(this.filtros.desde) && this.$utils.isValid(this.filtros.hasta);
          },
          url() {
        //Como el endpoint cambia dependiendo de la variable de entorno, se hace una validacion para que tome el correcto
        var endpoint = this.formulaNyx? 'OEERangoTurnosMaquiNyx' : 'OEERangoTurnos';//OEERangoTurnosNyx
        var url = `/OEEV2/${endpoint}?Desde=${this.filtros.desde}&Hasta=${this.filtros.hasta}`;
        /* url += this.$utils.arrays.urlQuery(this.filtros.idsTurnos,"IdsTurnos",false); */
        if(this.filtros.idsTurnos != null)
          url += this.$utils.arrays.urlQuery(this.filtros.idsTurnos,"IdsTurnos",false);
        
        url += this.$utils.arrays.urlQuery(this.filtros.idsAreas,"IdsAreas",false);
        url += this.$utils.arrays.urlQuery(this.filtros.idsOTS,"IdsOTS",false);
        url += this.$utils.arrays.urlQuery(this.filtros.idsArticulos,"IdsArticulos",false);
        url += this.$utils.arrays.urlQuery(this.filtros.idsMaquinaInstancias,"IdsMaquinasInstancias",false);
        url += this.$utils.arrays.urlQuery(this.filtros.idsPersonas,"IdsPersonas",false);
        url += this.$utils.arrays.urlQuery(this.filtros.idsClientes,"IdsClientes",false);
        return url;
          },
          tiempo(){
        return this.$utils.strings.toTime(this.segundos);
      },
      sameDay(){
        var desde = this.$utils.isValid(this.filtros.desde) ? moment(this.filtros.desde, "YYYY-MM-DD") : moment(1);
        var hasta = this.$utils.isValid(this.filtros.hasta) ? moment(this.filtros.hasta, "YYYY-MM-DD") : moment(1);
        return desde.isSameOrAfter(moment(),'day') || hasta.isSameOrAfter(moment(),'day');
      },

      // Variable temporal para controlar el desplegado de traficas simulando el OEE
      arielrNYX() {
        if(this.nombreEmpresa == 'Nyx' || this.nombreEmpresa == 'Glm') {
          return false
        }
        return true
      },
      },
      data(){
      return {
        seriesDisponibilidad: null,
        seriesBackDisponibilidad: null,
        seriesRendimiento: null,
        seriesBackRendimiento: null,
        seriesCalidad: null,
        seriesBackCalidad: null,
        seriesOee: null,
        seriesBackOee: null,
        datosBack : null,
        filtroDDisponibilidad:null ,
        filtroHDisponibilidad:null ,
        filtroDRendimiento:null ,
        filtroHRendimiento:null ,
        filtroDCalidad:null ,
        filtroHCalidad:null ,
        filtroDOee:null ,
        filtroHOee:null ,
        switch1: false,
        efode: false,
        efore: false,
        efoce: false,
        efoee: false,
      resumenHorasHeaders: [
        {
          text: "Dia",
          align: "center",
          value: "fecha"
        },
        {
          text: "Maquina",
          align: "center",
          value: "maquina"
        },
        {
          text: "Turno",
          align: "center",
          value: "turno"
        },
        {
          text: "Desde",
          align: "center",
          value: "desdeHora"
        },
        {
          text: "Hasta",
          align: "center",
          value: "hastaHora"
        },
        {
          text: "Piezas Teoricas",
          align: "center",
          value: "pzaTeoricas"
        },
        {
          text: "Total de piezas",
          align: "center",
          value: "pzaRealizadas"
        },
        {
          text: "Piezas No Ok",
          align: "center",
          value: "pzaNoOk"
        },
        {
          text: "TiempoMuerto",
          align: "center",
          value: "tiempoParo"
        },
        {
          text: "OEE",
          align: "center",
          value: "oee"
        },
        // { text: '', value: 'data-table-expand' },
      ],
      cargandoData:false,
      viewData:false,
      contador: 8,
          interval: null,
          segundos: 60,
          cargando: false,
      expanded: [],
      expanded1: [],
      expanded2: [],
      filtros: {
        desde: null,
        hasta: null,
        idsTurnos: [],
        idsAreas: [],
        idsOTS: [],
        idsArticulos: [],
        idsMaquinaInstancias: [],
        idsPersonas: [],
        idsClientes: []
      },
      turnos:[],
      areas:[],
      ots:[],
      articulos:[],
      maquinasIns:[],
      operadores:[],
      clientes:[],
      datos:{
        calidad: 0.0,
        disponibilidad: 0.0,
        eficiencia: 0.0,
        fecha: null,
        oee: 0.0,
        operaciones: [],
        piezasNoOk: 0,
        piezasOk: 0,
        piezasTeoricas: 0,
        resumenDias: [],
        scrap: 0.0,
        tiempoOperacionSeg: 0,
        tiempoParos: 0,
        totalPiezas: 0,
        resumenTurno: [],
        fechaFinDate: null,
        fechaInicioDate: null,
        operacionesCant: 0,
        std:null,
        tiempoBruto: 0,
        tiempoCiclo: 0,
        tiempoNeto: 0,
        peoresMaquinas:[],
      },
      datosDefault:{
        calidad: 0.0,
        disponibilidad: 0.0,
        eficiencia: 0.0,
        fecha: null,
        oee: 0.0,
        operaciones: [],
        piezasNoOk: 0,
        piezasOk: 0,
        piezasTeoricas: 0,
        resumenDias: [],
        scrap: 0.0,
        tiempoOperacionSeg: 0,
        tiempoParos: 0,
        totalPiezas: 0,
        resumenTurno: [],
        fechaFinDate: null,
        fechaInicioDate: null,
        operacionesCant: 0,
        std:0,
        tiempoBruto: 0,
        tiempoCiclo: 0,
        tiempoNeto: 0,
        peoresMaquinas:[],
      },
      serie1: [],
      chartOptions1:{
        chart: {
          id: 'disponibilidad',
          group: 'oee',
          type: 'bar',
          height: 160,
          toolbar: {
            show: false
          },
        },
        dataLabels: {
            enabled: false, // Ocultar los valores de la serie
          },
        colors: ['#118dff'],
        xaxis: {
          type: 'string',
          labels: {
            // datetimeUTC: false
          },
          tooltip: {
            enabled: false,
          }
        },
        yaxis: {
          labels: {
            formatter: function (val) {
              return val.toFixed(2)+'%';
            }
          },
          min: 0,
          tickAmount: 5,
        },
      },
      serie2: [],
      chartOptions2:{
        chart: {
          id: 'rendimiento',
          group: 'oee',
          type: 'bar',
          height: 160,
          toolbar: {
            show: false
          },
          events: {
            click: function(event, chartContext, config) {
                console.log("funciona")
            }
          }
        },
        colors: ['#ff8410'],
        xaxis: {
          type: 'string',
          labels: {
            // datetimeUTC: false
          },
          tooltip: {
            enabled: false
          }
        },
        yaxis: {
          labels: {
            formatter: function (val) {
              return val.toFixed(2)+'%';
            }
          },
          min: 0,
          tickAmount: 5,
        },
      },
      serie3: [],
      chartOptions3:{
        chart: {
          id: 'calidad',
          group: 'oee',
          type: 'bar',
          height: 160,
          toolbar: {
            show: false
          },
          events: {
            click: function(event, chartContext, config) {
                console.log("funciona")
            }
          }
        },
        colors: ['#10ff60'],
        xaxis: {
          type: 'string',
          labels: {
            // datetimeUTC: false
          },
          tooltip: {
            enabled: false
          }
        },
        yaxis: {
          labels: {
            formatter: function (val) {
              return val.toFixed(2)+'%';
            }
          },
          min: 0,
          tickAmount: 5,
        }
      },
      serie4: [],
      chartOptions4:{
        chart: {
          id: 'OEE',
          group: 'oee',
          type: 'bar',
          height: 160,
          toolbar: {
            show: false
          },
        },
        tooltip: {
            custom: function ({ series, seriesIndex, dataPointIndex, w }) {
              const data = series[seriesIndex][dataPointIndex];
              return '<div style="padding: 8px;">' +
                `<span>${data.x}</span><br>` +
                `<span>Valor Y: ${data.y}</span>` +
                '</div>';
            },
          },
        colors: ['#ff372b'],
        xaxis: {
          type: 'string',
          labels: {
            // datetimeUTC: false
          },
          tooltip: {
            enabled: true,
          }
        },
        yaxis: {
          labels: {
            formatter: function (val) {
              return val.toFixed(2)+'%';
            }
          },
          min: 0,
          tickAmount: 5,
        }
      },
      serie5: [],
      chartOptions5:{
        chart: {
          id: 'rendimiento',
          group: 'oee',
          type: 'bar',
          height: 220,
          toolbar: {
            show: false
          },
          events: {
            click: function(event, chartContext, config) {
                console.log("funciona")
            }
          }
        },
        colors: ['#118dff'],
        xaxis: {
          type: 'string',
          labels: {
            // datetimeUTC: false
          },
          tooltip: {
            enabled: false
          }
        },
        yaxis: {
          labels: {
            formatter: function (val) {
              return val.toFixed(2)+'%';
            }
          },
          min: 0,
          tickAmount: 5,
        },
      },
      serie6: [],
      chartOptions6:{
        chart: {
          id: 'rendimiento',
          group: 'oee',
          type: 'bar',
          height: 220,
          toolbar: {
            show: false
          },
          events: {
            click: function(event, chartContext, config) {
                console.log("funciona")
            }
          }
        },
        colors: ['#ff8410'],
        xaxis: {
          type: 'string',
          labels: {
            // datetimeUTC: false
          },
          tooltip: {
            enabled: false
          }
        },
        yaxis: {
          labels: {
            formatter: function (val) {
              return val.toFixed(2)+'%';
            }
          },
          min: 0,
          tickAmount: 5,
        },
      },
      serie7: [],
      chartOptions7:{
        chart: {
          id: 'calidad',
          group: 'oee',
          type: 'bar',
          height: 220,
          toolbar: {
            show: false
          },
          events: {
            click: function(event, chartContext, config) {
                console.log("funciona")
            }
          }
        },
        colors: ['#6B8E23'],
        xaxis: {
          type: 'string',
          labels: {
            // datetimeUTC: false
          },
          tooltip: {
            enabled: false
          }
        },
        yaxis: {
          labels: {
            formatter: function (val) {
              return val.toFixed(2)+'%';
            }
          },
          min: 0,
          tickAmount: 5,
        }
      },
      serie8: [],
      chartOptions8:{
        chart: {
          id: 'OEE',
          group: 'oee',
          type: 'bar',
          height: 220,
          toolbar: {
            show: false
          },
          events: {
            click: function(event, chartContext, config) {
                console.log("funciona")
            }
          }
        },
        tooltip: {
            custom: function ({ series, seriesIndex, dataPointIndex, w }) {
              const data = series[seriesIndex][dataPointIndex];
              return '<div style="padding: 8px;">' +
                `<span>${data.x}</span><br>` +
                `<span>Valor Y: ${data.y}</span>` +
                '</div>';
            },
          },
        colors: ['#ff372b'],
        xaxis: {
          type: 'string',
          labels: {
            // datetimeUTC: false
          },
          tooltip: {
            enabled: true,
          }
        },
        yaxis: {
          labels: {
            formatter: function (val) {
              return val.toFixed(2)+'%';
            }
          },
          min: 0,
          tickAmount: 5,
        }
      },
      serie9: [],
      chartOptions9:{
        chart: {
          id: 'OEE',
          group: 'oee',
          type: 'bar',
          height: 220,
          toolbar: {
            show: false
          },
          events: {
            click: function(event, chartContext, config) {
                console.log("funciona")
            }
          }
        },
        tooltip: {
            custom: function ({ series, seriesIndex, dataPointIndex, w }) {
              const data = series[seriesIndex][dataPointIndex];
              return '<div style="padding: 8px;">' +
                `<span>${data.x}</span><br>` +
                `<span>Valor Y: ${data.y}</span>` +
                '</div>';
            },
          },
        colors: ['#ff372b'],
        xaxis: {
          type: 'string',
          labels: {
            // datetimeUTC: false
          },
          tooltip: {
            enabled: true,
          }
        },
        yaxis: {
          labels: {
            formatter: function (val) {
              return val.toFixed(2)+'%';
            }
          },
          min: 0,
          tickAmount: 5,
        }
      },

      renderizar: false,
      headers:[
        {
          text: "OT",
          align: "center",
          sortable: false,
          value: "ot",
          // width: "50%",
        },
        {
          text: "Área",
          align: "center",
          sortable: false,
          value: "area",
          // width: "50%",
        },
        {
          text: "Artículo",
          align: "center",
          sortable: false,
          value: "articuloFase",
          // width: "50%",
        },
        { 
          text: "SubPaso",
          align: "center",
          sortable: true,
          value: "subpaso",
        },
        {
          text: "Operador(es)",
          align: "center",
          sortable: false,
          value: "personas",
          // width: "50%",
        },
        {
          text: "Máquina(s)",
          align: "center",
          sortable: false,
          value: "maquinas",
          // width: "50%",
        },
        {
          text: "Disponibilidad",
          align: "center",
          sortable: false,
          value: "disponibilidad",
          // width: "50%",
        },
        {
          text: "Rendimiento",
          align: "center",
          sortable: false,
          value: "eficiencia",
          // width: "50%",
        },
        {
          text: "Calidad",
          align: "center",
          sortable: false,
          value: "calidad",
          // width: "50%",
        },
        {
          text: "OEE",
          align: "center",
          sortable: false,
          value: "oee",
          // width: "50%",
        },
        { text: '', value: 'data-table-expand' },
      ],
      headersXDia:[
        {
          text: "Día",
          align: "center",
          sortable: false,
          value: "inicioString",
          // width: "50%",
        },        
        {
          text: "Tiempo Evaluado",
          align: "center",
          sortable: false,
          value: "tiempoBruto",
          // width: "50%",
        },
        {
          text: "Tiempo Activo",
          align: "center",
          sortable: false,
          value: "tiempoNeto",
          // width: "50%",
        },
        {
          text: "STD",
          align: "center",
          sortable: false,
          value: "std",
          // width: "50%",
        },
        {
          text: "Total Piezas",
          align: "center",
          sortable: false,
          value: "totalPiezas",
          // width: "50%",
        },
        {
          text: "Piezas Teoricas",
          align: "center",
          sortable: false,
          value: "piezasTeoricas",
          // width: "50%",
        },
        {
          text: "Piezas Ok",
          align: "center",
          sortable: false,
          value: "piezasOk",
          // width: "50%",
        },
        {
          text: "Piezas No Ok",
          align: "center",
          sortable: false,
          value: "piezasNoOk",
          // width: "50%",
        },
        {
          text: "Paros",
          align: "center",
          sortable: false,
          value: "reportes",
          // width: "50%",
        },
        {
          text: "Scrap",
          align: "center",
          sortable: false,
          value: "scrap",
          // width: "50%",
        },
        { text: '', value: 'data-table-expand' },
      ],
      headersXMaquina:[
        {
          text: "Día",
          align: "center",
          sortable: false,
          value: "fecha",
          // width: "50%",
        },        
        {
          text: "Máquina(s)",
          align: "center",
          sortable: false,
          value: "maquina",
          // width: "50%",
        },
        {
          text: "Turno",
          align: "center",
          sortable: false,
          value: "turno",
          // width: "50%",
        },
        {
          text: "Tiempo Muerto",
          align: "center",
          sortable: false,
          value: "tiempoMuerto",
          // width: "50%",
        },
        // {
        //   text: "Tiempo Evaluado",
        //   align: "center",
        //   sortable: false,
        //   value: "tiempoBruto",
        //   // width: "50%",
        // },
        // {
        //   text: "Tiempo Activo",
        //   align: "center",
        //   sortable: false,
        //   value: "tiempoNeto",
        //   // width: "50%",
        // },
        // {
        //   text: "STD",
        //   align: "center",
        //   sortable: false,
        //   value: "std",
        //   // width: "50%",
        // },
        {
          text: "Total Piezas",
          align: "center",
          sortable: false,
          value: "totalPiezas",
          // width: "50%",
        },
        {
          text: "Piezas Teoricas",
          align: "center",
          sortable: false,
          value: "piezasTeoricas",
          // width: "50%",
        },
        {
          text: "Piezas Ok",
          align: "center",
          sortable: false,
          value: "piezasOk",
          // width: "50%",
        },
        {
          text: "Piezas No Ok",
          align: "center",
          sortable: false,
          value: "piezasNoOk",
          // width: "50%",
        },
        {
          text: "Paros",
          align: "center",
          sortable: false,
          value: "reportes",
          // width: "50%",
        },
        {
          text: "Scrap",
          align: "center",
          sortable: false,
          value: "scrap",
          // width: "50%",
        },
        { text: '', value: 'data-table-expand' },
      ],
      // headersPeoresTop:[
      //   {
      //     text: "Día",
      //     align: "center",
      //     sortable: false,
      //     value: "fecha",
      //     // width: "50%",
      //   },        
      //   {
      //     text: "Máquina(s)",
      //     align: "center",
      //     sortable: false,
      //     value: "maquina",
      //     // width: "50%",
      //   },
      //   {
      //     text: "Turno",
      //     align: "center",
      //     sortable: false,
      //     value: "turno",
      //     // width: "50%",
      //   },             
      //   {
      //     text: "OEE",
      //     align: "center",
      //     sortable: false,
      //     value: "oee",
      //     // width: "50%",
      //   },
        
      // ],
      countVel:0,
      mismoDia: false,
      errores: [],
      error: false,
      }
    },
      methods: {
      nombreArticulo:(articulo) => `[${articulo.codigo}] - ${articulo.nombre}`,
      nombreMaquina: maquina => ` [${maquina.nombre}] - ${maquina.marca} ${maquina.modelo}`,
      nombrePersona: (persona) => persona.nombre + " " + persona.paterno + " " + persona.materno,
      getRoundedHour(date) {
        // Crear una nueva fecha con la misma hora pero los minutos y segundos ajustados a 0
        const roundedDate = new Date(date);
        roundedDate.setMinutes(0, 0, 0);
        return roundedDate.getTime();
      },
      consultar() {
        const empresa = (this.nombreEmpresa || '')
        if (empresa === 'TAMTO') {
          return this.obtenerDatosTamto();
        }
        return this.obtenerDatos();
      },
      generarSerie(nombre, campo){
        var serie = {
          name: nombre,
          data: []
        };
  
        if(this.datos.resumenDias != null && this.datos.resumenDias.length > 0){
          serie.data = this.datos.resumenDias.map(d =>{
            var fechaFormateada = this.formatoFechaHora(d.fecha);
            var dateObject = new Date(fechaFormateada);
            // Ajustar la fecha al inicio del día
            return {
              z: dateObject,
              x: dateObject.toLocaleDateString(),
              y: (this.nuevoReporteOee?d[campo]:d[campo]* 100 ),//
            }
          });
        }
     
        if(nombre =="Disponibilidad")
          this.seriesDisponibilidad = [serie];
        
        if(nombre =="Rendimiento")
          this.seriesRendimiento = [serie];
        
        if(nombre =="Calidad")
          this.seriesCalidad = [serie];
  
        if(nombre =="OEE")
          this.seriesOee = [serie];
        
        return [serie]; 
      },
      generarSerieTurno(nombre, campo){
        var serie = {
          name: nombre,
          data: []
        };
  
        if(this.datos.resumenTurno != null && this.datos.resumenTurno.length > 0){
          serie.data = this.datos.resumenTurno.map(d =>{
            // var fechaFormateada = this.formatoFechaHora(d.fecha);
            // var dateObject = new Date(fechaFormateada);
            return {
              z: d[campo],
              x: d.turno,
              y: (this.nuevoReporteOee?d[campo]:d[campo]* 100 ),//
            }
          });
        }
     
        // if(nombre =="Disponibilidad")
        //   this.seriesDisponibilidad = [serie];
        
        // if(nombre =="Rendimiento")
        //   this.seriesRendimiento = [serie];
        
        // if(nombre =="Calidad")
        //   this.seriesCalidad = [serie];
  
        // if(nombre =="OEE")
        //   this.seriesOee = [serie];
        
        return [serie]; 
      },
      generarSerieRanking(nombre, campo){
        var serie = {
          name: nombre,
          data: []
        };
  
        if(this.datos.peoresMaquinas != null && this.datos.peoresMaquinas.length > 0){
          serie.data = this.datos.peoresMaquinas.map(d =>{
            
            return {
              z: d.maquina,
              x: d.maquina,
              y: d[campo],//
            }
          });
        }  
                
        return [serie]; 
      },
      formatoFechaHora(fecha) {
         const fechaObj = new Date(fecha);
         const dia = String(fechaObj.getDate()).padStart(2, '0');
         const mes = String(fechaObj.getMonth() + 1).padStart(2, '0');
          const anio = fechaObj.getFullYear();
          // const horas = String(fechaObj.getHours()).padStart(2, '0');
          // const minutos = String(fechaObj.getMinutes()).padStart(2, '0');
  
          return new Date(anio, mes - 1, dia);//, horas, minutos
      },
      chartOptionsGenerador(id,color = '#008FFB'){
        if(this.datos.operacionesCant == 0){
          return {
            chart: {
              id: id,
              group: 'oee',
              type: 'bar',
              height: 220,
              toolbar: {
                show: false
              },
              zoom: {
                enabled: false
              }
            },
            colors: [color],
            xaxis: {
              type: 'string' ,
              labels: {
                datetimeUTC: false,
              },
              tooltip: {
                enabled: false,
               
              },
            },
            yaxis: {
              labels: {
                formatter: function (val) {
                  return val.toFixed(2)+'%';
                }
              },
              min: 0,
              tickAmount: 5,
            },
          };

        }
        const start = moment(this.filtros.desde,"YYYY-MM-DD");
        const end = moment(this.filtros.hasta,"YYYY-MM-DD");
        const diferenciaDias = Math.abs(moment.duration(start.diff(end)).asDays());
        const soloHoras = diferenciaDias <= 1;
        let actualDay = false;
        if(this.filtros.desde == this.filtros.hasta){
          const today = (new Date()).toISOString().split('T')[0];
          actualDay = today == this.filtros.desde;
        }
        
        return  {
          chart: {
            id: id,
            group: 'oee',
            type: 'bar',
            height: 220,
            toolbar: {
              show: false
            },
            zoom: {
              enabled: false
            }
          },
          colors: [color],
          xaxis: {
            type: 'string' ,
            // max: actualDay ? this.getRoundedHour(new Date()) : undefined,
            labels: {
              // formatter: (value) => moment(value).format("YYYY-MM-DD HH:mm"),
              // format: soloHoras ? "HH:mm" : "yyyy-MM-dd",
              // datetimeUTC: false,
            },
            tooltip: {
              enabled: false,
             
            },
          },
          yaxis: {
            labels: {
              formatter: function (val) {
                return val.toFixed(2)+'%';
              }
            },
            min: 0,
            tickAmount: 5,
          },
          tooltip: {
            x: {
              formatter: (value) => {
                //console.log("value "+value)
                return moment(value).format("YYYY-MM-DD");//format("YYYY-MM-DD HH:mm");
              }
            },
            custom: function ({ series, seriesIndex, dataPointIndex, w }) {
              var data = w.globals.initialSeries[seriesIndex].data[dataPointIndex];
              return '<div style="padding: 8px;">' +
                `${moment(data.x).format("YYYY-MM-DD")}<br>` +//.format("YYYY-MM-DD HH:mm")
                `${w.globals.chartID}: <b>${data.y}%</b>` +//(data.y).toFixed(2)
                '</div>';
            },
          }
        };
      },
      chartOptionsGeneradorTurno(id,color){
        
        return  {
          chart: {
            id: id,
            group: 'oee',
            type: 'bar',
            height: 160,
            toolbar: {
              show: false
            },
          },
          tooltip: {
              custom: function ({ series, seriesIndex, dataPointIndex, w }) {
                const data =  w.globals.initialSeries[seriesIndex].data[dataPointIndex];//series[seriesIndex][dataPointIndex];
                
                return '<div style="padding: 8px;">' +
                  `<span>${data.x}</span><br>` +
                  `<span> ${data.y}</span>` +
                  '</div>';
              },
            },
          colors: [color],
          xaxis: {
            type: 'string',
            labels: {
              // datetimeUTC: false
            },
            tooltip: {
              enabled: true,
            }
          },
          yaxis: {
            labels: {
              formatter: function (val) {
                return val.toFixed(2)+'%';
              }
            },
            min: 0,
            tickAmount: 5,
          }
        };
      },
      filtrarData(event, chartContext, config){
        var index = config.labelIndex;
        var value = config.globals.timescaleLabels[index].value;
        var value2 = config.globals.timescaleLabels[index].dateString;
        var grafica = config.globals.chartID;
  
        var fechaInicio = new Date(value2);
        var fechaFinal = new Date(fechaInicio);
        fechaFinal.setDate(fechaFinal.getDate() + 1);
        fechaFinal.setHours(0, 0, 0, 0);
        fechaFinal.setSeconds(fechaFinal.getSeconds() - 1);     
  
        if(grafica == 'Disponibilidad' && this.seriesBackDisponibilidad == null){
          this.seriesBackDisponibilidad = [...this.chartOptions1];
          this.efode = true;
        }
  
        if(grafica == 'Rendimiento' && this.seriesBackRendimiento == null){
          this.seriesBackRendimiento = [...this.chartOptions2];
          this.efore = true;
        }
  
        if(grafica == 'Calidad' && this.seriesBackCalidad == null){
          this.seriesBackCalidad = [...this.chartOptions3];
          this.efoce = true;
        }
  
        if(grafica == 'OEE' && this.seriesBackOee == null){
          this.seriesBackOee = [...this.chartOptions4];
          this.efoee = true;
        }
  
        var datosss = grafica == 'Disponibilidad' ? [this.seriesDisponibilidad[0]] : 
                        grafica == 'Rendimiento' ? [this.seriesRendimiento[0]] : 
                        grafica == 'Calidad' ? [this.seriesCalidad[0]] : 
                        grafica == 'OEE' ? [this.seriesOee[0]] : [];
  
                              
        const dataFiltrada = datosss.map(d => {
                return {
                   name: d.name,
                   data: d.data.filter(item => item.z >= fechaInicio && item.z <= fechaFinal )
                  };
                });
  
        if(this.datosBack == null) this.datosBack = [...this.datos.operaciones]
  
        if(grafica == 'Disponibilidad'){
          this.filtroDDisponibilidad = fechaInicio
          this.filtroHDisponibilidad = fechaFinal
        }
        
        if(grafica == 'Rendimiento'){
          this.filtroDRendimiento = fechaInicio
          this.filtroHRendimiento = fechaFinal
        }
  
        if(grafica == 'Calidad'){
          this.filtroDCalidad = fechaInicio
          this.filtroHCalidad = fechaFinal
        }
  
        if(grafica == 'OEE'){
          this.filtroDOee = fechaInicio
          this.filtroHOee =fechaFinal
        }
  
        this.datosFiltrada();
                    
        if(grafica == 'Disponibilidad')
           this.chartOptions1 = dataFiltrada;
        
        if(grafica == 'Rendimiento')
          this.chartOptions2 = dataFiltrada;
  
        if(grafica == 'Calidad')
          this.chartOptions3 = dataFiltrada;
        
        if(grafica == 'OEE')
          this.chartOptions4 = dataFiltrada;
                
      },
      eliminarFiltro(grafica) {
        if(grafica == 1){
          this.efode = false;
          this.chartOptions1 = [...this.seriesBackDisponibilidad];
          this.seriesBackDisponibilidad = null;
          this.filtroDDisponibilidad = null;
          this.filtroHDisponibilidad = null;
        }
        if(grafica == 2){
          this.efore = false;
          this.chartOptions2 = [...this.seriesBackRendimiento];
          this.seriesBackRendimiento = null;
          this.filtroDRendimiento = null;
          this.filtroHRendimiento = null;
        }
        if(grafica == 3){
          this.efoce = false;
          this.chartOptions3 = [...this.seriesBackCalidad];
          this.seriesBackCalidad = null;
          this.filtroDCalidad = null;
          this.filtroHCalidad = null;
        }
        if(grafica == 4){
          this.chartOptions4 = [...this.seriesBackOee];
          this.seriesBackOee = null;
          this.efoee = false;
          this.filtroDOee = null;
          this.filtroHOee = null;
        }
        this.datosFiltrada()
        if(this.filtroHDisponibilidad == null && this.filtroHRendimiento == null && this.filtroHCalidad == null && this.filtroHOee == null && this.filtroDDisponibilidad == null && this.filtroDRendimiento == null && this.filtroDCalidad == null && this.filtroDOee == null)
            this.datos.operaciones = [...this.datosBack]
      },
      datosFiltrada(){
        var arrayModificado = this.datosBack.map(objeto => {
                     var objetoModificado = { ...objeto };
                     var fI = new Date(objeto.inicioString);
                     var fF = new Date(objeto.finString);
                     objetoModificado.inicioString = fI;
                     objetoModificado.finString = fF;
                     return objetoModificado;
                  });
                  var filtrado = null;
  
        if(this.filtroDDisponibilidad != null && this.filtroHDisponibilidad != null)
          {
            console.log("Entra 1")
            filtrado = arrayModificado.filter(item => item.inicioString >= this.filtroDDisponibilidad && item.finString <= this.filtroHDisponibilidad)}
  
        if(this.filtroDRendimiento != null && this.filtroHRendimiento != null)
          {
            console.log("Entra 2")
            filtrado = arrayModificado.filter(item => item.inicioString >= this.filtroDRendimiento && item.finString <= this.filtroHRendimiento)}
  
        if(this.filtroDCalidad != null && this.filtroHCalidad != null)
          {console.log("Entra 3")
            filtrado = arrayModificado.filter(item => item.inicioString >= this.filtroDCalidad && item.finString <= this.filtroHCalidad)}
  
        if(this.filtroDOee != null && this.filtroHOee != null)
          {
            console.log("Entra 4")
            filtrado = arrayModificado.filter(item => item.inicioString >= this.filtroDOee && item.finString <= this.filtroHOee)}
  
        this.datos.operaciones = filtrado;
      },
      initialize() {
        this.getTurnos();
        this.getAreas();
        this.getOTS();
        this.getArticulos();
        this.getMaquinasIns();
        this.getOperadores();
        this.getClientes();
        if(this.formulaNyx)
        {
          this.cambiarColumns()
        }
          },
      resetCampo(posicion){
        switch (posicion) {
          case 1:
            this.filtros.idsTurnos = [];
            break;
          case 2:
            this.filtros.idsAreas = [];
            break;
          case 3:
            this.filtros.idsOTS = [];
            break;
          case 4:
            this.filtros.idsArticulos = [];
            break;
          case 5:
            this.filtros.idsMaquinaInstancias = [];
            break;
          case 6:
            this.filtros.idsPersonas = [];
            break;
          case 7:
            this.filtros.idsClientes = [];
            break;
          default:
            break;
        }
      },
      stopTimer(newValue) {
        if (newValue)
          this.active = true; 
          else
          this.active = false;
      },
          obtenerDatos() {
              if (this.validate()) return;              
              
              if (!this.realizarPeticion || this.cargando) return;
  
              if(this.modoProyeccion){
                this.filtros.idsTurnos = this.idTurnoActual;
              }
              
              this.cargando = true;
              this.segundos = 60;
              this.cargandoData = true;
              this.mismoDia=this.filtros.desde==this.filtros.hasta? true : false;
              axios
              .get(this.url)
              .then((response) => {
                if(response.data == null){
                  this.datos = this.datosDefault;   
                  
                }else{
                  this.datos = response.data;
                  //console.log(this.datos);                 
                }
                this.chartOptions1 = this.generarSerie('Disponibilidad','disponibilidad');
                this.serie1 = this.chartOptionsGenerador('Disponibilidad','#118dff');

                this.chartOptions2 = this.generarSerie(this.oeeRendimientoLabel,'eficiencia');
                this.serie2 = this.chartOptionsGenerador(this.oeeRendimientoLabel,'#ff8410');

                this.chartOptions3 = this.generarSerie('Calidad','calidad');
                this.serie3 = this.chartOptionsGenerador('Calidad','#10ff60');

                this.chartOptions4 = this.generarSerie('OEE','oee');
                this.serie4 = this.chartOptionsGenerador('OEE','#ff372b');

                if(!this.validarNuevoReporte()){
                  this.chartOptions5 = this.generarSerieTurno('Disponibilidad','disponibilidad');
                  this.serie5 = this.chartOptionsGeneradorTurno('Disponibilidad','#118dff');

                  this.chartOptions6 = this.generarSerieTurno(this.oeeRendimientoLabel,'eficiencia');
                  this.serie6 = this.chartOptionsGeneradorTurno(this.oeeRendimientoLabel,'#ff8410');

                  this.chartOptions7 = this.generarSerieTurno('Calidad','calidad');
                  this.serie7 = this.chartOptionsGeneradorTurno('Calidad','#6B8E23');

                  this.chartOptions8 = this.generarSerieTurno('OEE','oee');
                  this.serie8 = this.chartOptionsGeneradorTurno('OEE','#ff372b');
                }                  
                // if(this.formulaNyx){}
                this.chartOptions9 = this.generarSerieRanking('OEE','oee');
                this.serie9 = this.chartOptionsGeneradorTurno('OEE','#ff372b');
                
                this.renderizar = true;
                this.cargando = false;
                this.cargandoData = false;
                this.viewData = true;
          
              })
              .catch((error) => {
                this.datos = this.datosDefault; 
                this.chartOptions1 = this.generarSerie('Disponibilidad','disponibilidad');
                this.serie1 = this.chartOptionsGenerador('Disponibilidad','#118dff');

                this.chartOptions2 = this.generarSerie(this.oeeRendimientoLabel,'eficiencia');
                this.serie2 = this.chartOptionsGenerador(this.oeeRendimientoLabel,'#ff8410');

                this.chartOptions3 = this.generarSerie('Calidad','calidad');
                this.serie3 = this.chartOptionsGenerador('Calidad','#10ff60');

                this.chartOptions4 = this.generarSerie('OEE','oee');
                this.serie4 = this.chartOptionsGenerador('OEE','#ff372b');

                if(!this.validarNuevoReporte()){
                  this.chartOptions5 = this.generarSerieTurno('Disponibilidad','disponibilidad');
                  this.serie5 = this.chartOptionsGeneradorTurno('Disponibilidad','#118dff');

                  this.chartOptions6 = this.generarSerieTurno(this.oeeRendimientoLabel,'eficiencia');
                  this.serie6 = this.chartOptionsGeneradorTurno(this.oeeRendimientoLabel,'#ff8410');

                  this.chartOptions7 = this.generarSerieTurno('Calidad','calidad');
                  this.serie7 = this.chartOptionsGeneradorTurno('Calidad','#10ff60');

                  this.chartOptions8 = this.generarSerieTurno('OEE','oee');
                  this.serie8 = this.chartOptionsGeneradorTurno('OEE','#ff372b');
                }
                if(this.formulaNyx){
                  this.chartOptions9 = this.generarSerieRanking('OEE','oee');
                  this.serie9 = this.chartOptionsGeneradorTurno('OEE','#ff372b');
                }
                this.cargando = false;
                this.viewData = true;
                this.cargandoData = false;
                if(error.response.status == 404){
                  this.datos.calidad = 100;
                  this.datos.disponibilidad = 100;
                  this.datos.eficiencia = 100;
                  this.datos.oee = 100;
                  this.errores = [];
                  this.error = true;
                  this.errores.push(
							      "No se han programado actividades para este turno"
						      );
                }
                console.log(error);
              });
        this.countVel++
          },
          buildUrlTamto(path) {
          let url = `${path}?Desde=${this.filtros.desde}&Hasta=${this.filtros.hasta}`;
          url += this.$utils.arrays.urlQuery(this.filtros.idsTurnos, "IdsTurnos", false);
          url += this.$utils.arrays.urlQuery(this.filtros.idsAreas, "IdsAreas", false);
          url += this.$utils.arrays.urlQuery(this.filtros.idsOTS, "IdsOTS", false);
          url += this.$utils.arrays.urlQuery(this.filtros.idsArticulos, "IdsArticulos", false);
          url += this.$utils.arrays.urlQuery(this.filtros.idsMaquinaInstancias, "IdsMaquinasInstancias", false);
          url += this.$utils.arrays.urlQuery(this.filtros.idsPersonas, "IdsPersonas", false);
          url += this.$utils.arrays.urlQuery(this.filtros.idsClientes, "IdsClientes", false);
          if (this.filtros.eficiencia != null) url += `&IdEficiencia=${this.filtros.eficiencia}`; // <- corregí el typo
          return url;
        },
          async obtenerDatosTamto() {
              if (this.validate()) return;
              if (!this.realizarPeticion || this.cargando) return;

              if (this.modoProyeccion) this.filtros.idsTurnos = this.idTurnoActual;

              this.cargando = true;
              this.segundos = 60;
              this.cargandoData = true;
              this.mismoDia = this.filtros.desde == this.filtros.hasta;

              const oeeUrl = this.buildUrlTamto("/OEEV2/OEERangoTurnos");
              // 2) Eficiencias del otro EP (si “hacer trampa”)
              const repCalidadUrl = this.buildUrlTamto("/Reportes/ReporteCalidadSubpasos");

              try {
                const [oeeResp, repCalResp] = await Promise.all([
                  axios.get(oeeUrl),
                  axios.get(repCalidadUrl, { params: { extemporaneo: this.filtros.extemporaneo ?? null } }),
                ]);

                this.datos = oeeResp.data ?? this.datosDefault;

                const mapa = new Map();
                const lista = Array.isArray(repCalResp.data) ? repCalResp.data : [];
                for (const r of lista) {
                  if (r?.idOperacionReal == null) continue;
                  const e = Number(r.eficiencia);
                  if (!Number.isFinite(e)) continue;

                  let dur = 0;
                  if (r.inicio && r.fin) {
                    const ini = new Date(String(r.inicio).replace(' ', 'T'));
                    const fin = new Date(String(r.fin).replace(' ', 'T'));
                    dur = Math.max(0, (fin - ini) / 1000);
                  }
                  const prev = mapa.get(r.idOperacionReal);
                  if (!prev || dur > prev.dur || (dur === prev?.dur && e > prev.e)) {
                    mapa.set(r.idOperacionReal, { e, dur });
                  }
                }

                if (this.datos?.operaciones?.length) {
                  this.datos.operaciones = this.datos.operaciones.map(op => {
                    const hit = mapa.get(op.idOperacionReal);
                    if (hit) return { ...op, eficiencia: hit.e };
                    return op;
                  });
                }
                //this.datos = oeeData;

                this.chartOptions1 = this.generarSerie('Disponibilidad','disponibilidad');
                this.serie1        = this.chartOptionsGenerador('Disponibilidad','#118dff');

                this.chartOptions2 = this.generarSerie(this.oeeRendimientoLabel,'eficiencia');
                this.serie2        = this.chartOptionsGenerador(this.oeeRendimientoLabel,'#ff8410');

                this.chartOptions3 = this.generarSerie('Calidad','calidad');
                this.serie3        = this.chartOptionsGenerador('Calidad','#10ff60');

                this.chartOptions4 = this.generarSerie('OEE','oee');
                this.serie4        = this.chartOptionsGenerador('OEE','#ff372b');

                if (!this.validarNuevoReporte()) {
                  this.chartOptions5 = this.generarSerieTurno('Disponibilidad','disponibilidad');
                  this.serie5        = this.chartOptionsGeneradorTurno('Disponibilidad','#118dff');

                  this.chartOptions6 = this.generarSerieTurno(this.oeeRendimientoLabel,'eficiencia');
                  this.serie6        = this.chartOptionsGeneradorTurno(this.oeeRendimientoLabel,'#ff8410');

                  this.chartOptions7 = this.generarSerieTurno('Calidad','calidad');
                  this.serie7        = this.chartOptionsGeneradorTurno('Calidad','#6B8E23');

                  this.chartOptions8 = this.generarSerieTurno('OEE','oee');
                  this.serie8        = this.chartOptionsGeneradorTurno('OEE','#ff372b');
                }

                this.chartOptions9 = this.generarSerieRanking('OEE','oee');
                this.serie9        = this.chartOptionsGeneradorTurno('OEE','#ff372b');

                this.renderizar  = true;
                this.viewData    = true;
              } catch (error) {

                this.datos = this.datosDefault;
                this.chartOptions1 = this.generarSerie('Disponibilidad','disponibilidad');
                this.serie1        = this.chartOptionsGenerador('Disponibilidad','#118dff');

                this.chartOptions2 = this.generarSerie(this.oeeRendimientoLabel,'eficiencia');
                this.serie2        = this.chartOptionsGenerador(this.oeeRendimientoLabel,'#ff8410');

                this.chartOptions3 = this.generarSerie('Calidad','calidad');
                this.serie3        = this.chartOptionsGenerador('Calidad','#10ff60');

                this.chartOptions4 = this.generarSerie('OEE','oee');
                this.serie4        = this.chartOptionsGenerador('OEE','#ff372b');

                if (!this.validarNuevoReporte()) {
                  this.chartOptions5 = this.generarSerieTurno('Disponibilidad','disponibilidad');
                  this.serie5        = this.chartOptionsGeneradorTurno('Disponibilidad','#118dff');

                  this.chartOptions6 = this.generarSerieTurno(this.oeeRendimientoLabel,'eficiencia');
                  this.serie6        = this.chartOptionsGeneradorTurno(this.oeeRendimientoLabel,'#ff8410');

                  this.chartOptions7 = this.generarSerieTurno('Calidad','calidad');
                  this.serie7        = this.chartOptionsGeneradorTurno('Calidad','#10ff60');

                  this.chartOptions8 = this.generarSerieTurno('OEE','oee');
                  this.serie8        = this.chartOptionsGeneradorTurno('OEE','#ff372b');
                }

                if (this.formulaNyx) {
                  this.chartOptions9 = this.generarSerieRanking('OEE','oee');
                  this.serie9        = this.chartOptionsGeneradorTurno('OEE','#ff372b');
                }

                if (error?.response?.status === 404) {
                  this.datos.calidad = 100;
                  this.datos.disponibilidad = 100;
                  this.datos.eficiencia = 100;
                  this.datos.oee = 100;
                  this.errores = ["No se han programado actividades para este turno"];
                  this.error = true;
                }
                console.log(error);
              } finally {
                this.cargando = false;
                this.cargandoData = false;
                this.countVel++;
              }
            },
      getAreas() {
              axios
              .get("/Areas")
              .then((response) => {
                  this.areas = response.data.filter(a => a.idArea > 1);
              })
              .catch((error) => {
                  console.log(error);
              });
          },
          getTurnos() {
              axios
              .get("/Turnos")
              .then((response) => {
                  this.turnos = response.data;
              })
              .catch((error) => {
                  console.log(error);
              });
          },
      getOTS() {
              axios
                  .get(`/TrabajoOrdenes/TrabajoOrdenHeaders?soloEnProgreso=${false}`)
                  .then((response) => {
                      this.ots = response.data;
                  })
                  .catch((error) => {
                      console.log(error);
                  });
          },
      getArticulos() {
              axios
                  .get("/Articulos/OTS")
                  .then((response) => {
                      this.articulos = response.data;
                  })
                  .catch((error) => {
                      console.log(error);
                  });
          },
      getMaquinasIns(){
        axios
        .get("/MaquinaInstancias")
        .then(response => {
          this.maquinasIns = response.data;
        })
        .catch(error => {
          console.log(error);
        })
      },
      getOperadores() {
              axios
              .get("/Personas/Operadores")
              .then((response) => {
                  this.operadores = response.data;
              })
              .catch((error) => {
                  console.log(error);
              });
          },
      getClientes(){
        axios
        .get("/Clientes")
        .then(response => {
          response.data.unshift({
            idCliente: -1,
            nombre: this.nombreEmpresa,
          });
          this.clientes = response.data;
        })
        .catch(error => {
          console.log(error);
        });
      },
      url2(path) {
        var url = `${path}?Desde=${this.filtros.desde}&Hasta=${this.filtros.hasta}`;
        url += this.$utils.arrays.urlQuery(this.filtros.idsTurnos,"IdsTurnos",false);
        url += this.$utils.arrays.urlQuery(this.filtros.idsAreas,"IdsAreas",false);
        url += this.$utils.arrays.urlQuery(this.filtros.idsOTS,"IdsOTS",false);
        url += this.$utils.arrays.urlQuery(this.filtros.idsArticulos,"IdsArticulos",false);
        url += this.$utils.arrays.urlQuery(this.filtros.idsMaquinaInstancias,"IdsMaquinasInstancias",false);
        url += this.$utils.arrays.urlQuery(this.filtros.idsPersonas,"IdsPersonas",false);
        url += this.$utils.arrays.urlQuery(this.filtros.idsClientes,"IdsClientes",false);
        return url;
          },
      descargarReporte(){
        var datetime = moment().format('YYYYMMDDHHmmss');//OEEReport
        this.$utils.axios.downloadFile(this.url2("/OEEV2/OEEReportTurnos"),'GET','reporte-oee-'+datetime+'.xlsx','application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
      },
      validarNuevoReporte(){
        //La unica condición con  la cual se quitaran las graficas es para el nuevo reporte OEE y que la fecha desde y hasta sean iguales
        if(this.nuevoReporteOee && this.mismoDia){
          return false;
        }else{
          return true;
        }
      },
      cambiarColumns(){//Dependiendo del valor de la variable this.editedItem.iniciarAuto se cambian las columnas de la tabla
        this.headersXDia.splice(3,1,         
          {
            text: "Tiempo Ciclo",
            align: "center",
            sortable: false,
            value: "tiempoCiclo",
            // width: "50%",
          },
        ); 
      // if(this.editedItem.iniciarAuto){
        
        
      // }else {        
      //   this.headers.splice(3,1,         
      //   {
      //     text: "STD",
      //     align: "center",
      //     sortable: false,
      //     value: "std",
      //     // width: "50%",
      //   },
      //   ); 
      },
      validate() {
			this.errores = [];
      
			if (this.filtros.desde==null || this.filtros.hasta==null) {
				this.errores.push(
							"La consulta debe de incluir una fecha de inicio y una fecha de fin"
						);
        
			}			
			this.error = this.errores.length > 0;
			return this.errores.length > 0 ;
		  },           
    },
    filters: {
      formatToPercentage(value){
        return (value ).toFixed(2) + "%";//* 100
      },
      formatStringFecha(value){
        return value.slice(0,-3).split("T").join(" ");
      }
    },
      mounted() {
        if (this?.nombreEmpresa !== 'TAMTO') {
          if (this.headers[7]) {
            this.headers[7].text = this.oeeRendimientoLabel ?? 'Rendimiento';
          }
        }

        if (this.modoProyeccion) {
          this.filtros.desde = this.today;
          this.filtros.hasta = this.today;
          this.segundos = 0;
        }

        this.interval = setInterval(() => {
          if (!this.active) return;
          if (this.segundos <= 0 && this.sameDay) this.obtenerDatos();
          else this.segundos -= 1;
        }, 1000);

        this.initialize();
      },
      destroyed() {
          clearInterval(this.interval);
      },
  };
  </script>